export default {"src":"/_next/static/media/info_dark_green.a3b9be62.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};